<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <path
      id="np_gift_1706894_000000"
      d="M16.2,5a2.8,2.8,0,0,0-2.312,1.225A2.593,2.593,0,0,0,9.813,9.4H5.6A.624.624,0,0,0,5,10v3.6a.624.624,0,0,0,.6.6h.6v8.2a.624.624,0,0,0,.6.6H21.2a.624.624,0,0,0,.6-.6V14.2h.6a.624.624,0,0,0,.6-.6V10a.624.624,0,0,0-.6-.6H18.495A2.8,2.8,0,0,0,16.2,5Zm0,1.2a1.6,1.6,0,1,1,0,3.2H14.6V7.8A1.591,1.591,0,0,1,16.2,6.2ZM12,6.6A1.391,1.391,0,0,1,13.4,8V9.4H12a1.4,1.4,0,1,1,0-2.8Zm-5.8,4h7.2V13H6.2Zm8.4,0h7.2V13H14.6ZM7.4,14.2h6v7.6h-6Zm7.2,0h6v7.6h-6Z"
      transform="translate(-5.001 -5)"
    />
  </svg>
</template>
